// default options
const defaultOptions = {
    duration: 2000,
    'confirmModal': null,
}

export default class Api {
    constructor(name) {
        window[name] = this.data()
    }
    data(options = {}) {
        return {
            options: Object.assign({}, defaultOptions, options), // options,
            // options: {},
            methods: ["GET", "POST", "PUT", "DELETE"],
            data: {
                items: [],
            },
            loading: false,
            loaders: [], // specific loaders for a call
            error: false,
            isLoading(loading) {
                this.loading = loading;
            },
            setLoaderState(id, isLoading) {
                this.loaders[id] = isLoading;
            },
            call(action, body = {}, method = 'POST', id = null) {
                this.isLoading(true);
                this.setLoaderState(id, true);

                // catch invalid methods
                if (!this.methods.includes(method)) {
                    return;
                }

                // send to endpoint
                fetch(action, {
                    method: method,
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': document.head.querySelector('meta[name=csrf-token]').content,
                    },
                    body: method === 'GET' ? null : JSON.stringify(body),
                })
                    .then(response => {
                        // collect response data (oke / failed) based on the http status code
                        return response.json().then(data => ({
                            error: !response.ok, // [MDN] the ok read-only property of the Response interface contains a boolean stating whether the response was successful (status in the range 200-299) or not.
                            status: response.status, // status code of the response (e.g., 200 for a success)
                            errors: typeof data.errors !== 'undefined' ? data.errors : null, // array with error messages (eg: Field X must be a number)
                            message: data.message, //
                            options: typeof data.options !== 'undefined' ? data.options : [],
                            data: typeof data.data !== 'undefined' ? data.data : [],
                        }))
                    })
                    .then(response => {
                        if (response.error === true) {
                            return;
                        }

                        // data
                        this.data = response.data;

                        if (typeof response.options.dispatch !== 'undefined' && response.options.dispatch.length > 0) {
                            // send custom event
                            let event = new CustomEvent(response.options.dispatch);
                            window.dispatchEvent(event);
                        }

                        // redirect (if requested)
                        if (typeof response.options.redirect !== 'undefined') {
                            // redirect after the notification is gone (notyf does not have dismiss trigger)
                            setTimeout(() => {
                                // redirect
                                window.location.replace(response.options.redirect);
                            }, this.options.duration);
                        }

                        // reload if requested
                        if (typeof response.options.reload !== 'undefined' && response.options.reload === true) {
                            // redirect after the notification is gone (notyf does not have dismiss trigger)
                            setTimeout(() => {
                                // redirect
                                window.location.reload();
                            }, this.options.duration);
                        }

                        // reload (if requested)
                        if (this.options.reload === true) {
                            setTimeout(() => {
                                // reload
                                window.location.reload();
                            }, this.options.duration);
                        }

                        this.isLoading(false);
                        this.setLoaderState(id, false);
                    })
                    .catch((e) => {
                        // todo
                    })
                    .finally(() => {
                        setTimeout(() => {
                            this.isLoading(false);
                            this.setLoaderState(id, false);
                        }, this.options.duration);
                    })
            }
        }
    }

}
